import styled from '@emotion/styled';
import AttachedTag from '../../AttachedTags/AttachedTag';

const ClickableTag = styled(AttachedTag.withComponent('span'))(({ theme }) => ({
  marginBottom: 0,
  cursor: 'pointer',
  transition: theme.transitions.create('all'),
  ':hover': {
    transform: 'scale(1.05)',
  },
  ':active': {
    transform: 'scale(0.95)',
  },
}));

export default ClickableTag;
